<div class="custom-label">
  <mat-icon>blur_on</mat-icon>
  <mat-label> {{ props.label }} {{ props.required ? '*' : '' }} </mat-label>
  @if (props['tooltip']) {
    <button
      matIconButton
      class="info-icon-custom-label"
      type="button"
      #tooltip="matTooltip"
      [matTooltip]="props['tooltip']"
      matTooltipPosition="above"
      [matTooltipDisabled]="!props['tooltip']"
      (mouseenter)="props['tooltip'] && tooltip.show()"
      (mouseleave)="tooltip.hide()"
      (click)="openDialog()"
    >
      <mat-icon class="outline">help</mat-icon>
    </button>
  }
</div>
